import React from 'react';
import { connect } from 'react-redux';

import { updateActiveCms } from 'actions/LayoutActions';

import Data from 'components/Data';
import CmsPage from 'components/CmsPage';

import Loader from 'components/layout/Loader';
import CookieOptOut from 'components/layout/CookieOptOut';

class PrivacyPolicy extends React.Component {
  componentDidMount = () => {
    this.props.updateActiveCms('cmsSystemPagePrivacyPolicy');
  };

  componentWillUnmount = () => {
    this.props.updateActiveCms(null);
  };

  render() {
    const { cmsPage, height } = this.props;

    return (
      <>
        {!cmsPage.data.id && (
          <Data dataName="cmsSystemPagePrivacyPolicy" url="/api/pages/privacypolicy.json" data={cmsPage} />
        )}

        {cmsPage.pending ? (
          <div className="content relative" style={{ height: `${height}px` }}>
            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%)' }}>
              <Loader />
            </div>
          </div>
        ) : (
          <>
            <CmsPage data={cmsPage.data} doUpdateActiveCms={false} />
            <CookieOptOut />
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    height: state.layout.height,
    cmsPage: state.data.cmsSystemPagePrivacyPolicy,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    updateActiveCms: activeCms => {
      dispatch(updateActiveCms(activeCms));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrivacyPolicy);
